import { Component } from 'react'
import http from './../http'
class UploadFilesService extends Component {
    uploadEncrypt(data, onUploadProgress) {
        let {file,password} = data ;
        let formData = new FormData();
        formData.append("userpic", file);
        formData.append("password", password);
        return http.post("/encrypt/", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        });
    }

    uploadDecrypt(data, onUploadProgress) {
        let {file,password} = data ;
        let formData = new FormData();
        formData.append("image_user", file);
        formData.append("password", password);
        return http.post("/decrypt/", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        });
    }
    // getFiles() {
    //     return http.get("/files");
    // }
}

export default new UploadFilesService()